module.exports = __webpack_public_path__ + "img/shot_img20022504.4f4ae146.gif";